<template>
  <div class="registration-page transfer-company-section">
    <div class="registration-page-container">
      <div class="section">
        <div class="section-header"><h3>가입내역(번호이동)</h3></div>
        <div class="section-body">
          <dl class="field-group">
            <dt class="field-label">
              번호이동전화번호
            </dt>
            <dd class="field-control">
              <div class="field-control-sub">
                <p class="data-text">
                  {{ chgHopTlno }}
                </p>
              </div>
            </dd>
          </dl>
          <dl class="field-group">
            <dt class="field-label">
              변경전 통신사
            </dt>
            <dd class="field-control">
              <div class="field-control-sub">
                <p class="data-text">
                  {{ noRnftEnprNm }}
                </p>
              </div>
            </dd>
          </dl>
          <dl class="field-group">
            <dt class="field-label">
              번호이동 정보
            </dt>
            <dd class="field-control">
              <div class="field-control-sub">
                <p class="data-text" v-if="registration.mnpSoacTrgtCd !== '1'">
                  {{ mnpSoacTrgtNm }}<span>({{ registration.mnpSoacNo }})</span>
                </p>
                <p class="data-text" v-if="registration.mnpSoacTrgtCd === '1'">
                  {{ mnpSoacTrgtNm }}
                </p>
              </div>
            </dd>
          </dl>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { store } from '@/store'
export default {
  name: 'TransferCompanySectionView',
  props: {
    registrationProps: Object
  },

  data() {
    return {
      registration: {},
      chgHopTlno: '',
    }
  },

  mounted() {
    this.registration = this.registrationProps
    this.chgHopTlno = this.formatPhoneNumber(this.registration.chgHopTlno)
  },
  computed: {
    noRnftEnprNm() {
      if (this.registration.noRnftEnprCd === 'SKT') return 'SKT'
      if (this.registration.noRnftEnprCd === 'KT' || this.registration.noRnftEnprCd === 'KTF') return 'KT'
      if (this.registration.noRnftEnprCd === 'R') return '알뜰폰'
      return ''
    },

    mnpSoacTrgtNm() {
      if (this.registration.mnpSoacTrgtCd === '2')
        return '휴대폰 일련번호 뒷 네자리'
      if (this.registration.mnpSoacTrgtCd === '3')
        return '요금납부 은행 계좌번호 뒷 네자리'
      if (this.registration.mnpSoacTrgtCd === '5')
        return '요금납부 신용카드 뒷 네자리'
      if (this.registration.mnpSoacTrgtCd === '1') return '지로'
      return ''
    }
  },

  methods: {
    /** 
     * Function    : formatPhoneNumber
     * Description : 휴대폰 번호 formatting
     **/
    formatPhoneNumber(phoneNum) {
      if (phoneNum.length === 10) {
        return (
          phoneNum.substring(0, 3) +
          '-' +
          phoneNum.substring(3, 6) +
          '-' +
          phoneNum.substring(6, 10)
        )
      } else {
        return (
          phoneNum.substring(0, 3) +
          '-' +
          phoneNum.substring(3, 7) +
          '-' +
          phoneNum.substring(7, 11)
        )
      }
    }
  },

}
</script>

<style scoped></style>
